import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
//import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import SearchIcon from '@material-ui/icons/Search'
import Y from '../../y18n'
import Styles from '../styles'
//import tableToolbar from '../table-toolbar';
import { MenuItem } from '@material-ui/core';

const ToolbarStyle = {
  // MEDIA QUERY, filterContainer has to be a column on mobile devices
  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-evenly'
  },
  filterField: {
    display: 'flex',
    flex: 'flex-grow',
    minWidth: '160px',
    marginTop: '15px'

  }
}
                                       
class TableToolbarFilter extends Component {
  state = {
    searchText: '',
    searchActive: false,
    isEmpty: false
  }

  inputChanged = name => e => {
    this.setState({ [name]: e.target.value })
    if(e.target.value === "")
      this.setState({ isEmpty: true })
    else if(e.target.value.length > 0 && this.state.isEmpty)
      this.setState({ isEmpty: false})
  }

  setValue = (value) => {
    if(!this.state.searchText && !this.state.isEmpty)
      if(value)
        return value

    return this.state.searchText
  }

  submitSearch = e => {
    e.preventDefault()
    this.props.onSearch(this.state.searchText)
  }

  render(){

    const {title, 
           value,
           selection,
           filterProps,
           onAdd, 
           onDelete,
           onSearch, 
           classes
          } = this.props

    return (
      <div>
        <Toolbar
          className={classNames(classes.root, {
            [classes.highlight]: selection && selection.length > 0
          })}
        >
          {!title ? null :
          <div className={classes.title}>
            {selection && selection.length > 0
              ? <Typography variant='title'>{selection.length} {Y`${title}`} {Y`selected`}</Typography>
              : <Typography variant='title' classes={{ title: classes.title }}>
                {Y`${title}`}
              </Typography>}
          </div>
          }
          <div className={classes.toolbarSpacer} />

          {!onAdd || (selection && selection.length > 0) ? (
            <div className={classes.actions}>
              {!onDelete ? null : (
                <IconButton aria-label={Y`Delete`} onClick={() => onDelete(selection)}>
                  <DeleteIcon />
                </IconButton>
              )}
            </div>):(
            <div className={classes.actions}>
              <Button
                className={classes.button}
                variant='raised'
                color='primary'
                onClick={() => onAdd()}
                style={{ color: '#fff' }}
                >
                <AddIcon className={classes.leftIcon} />
                {Y`Add`}
              </Button>
            </div>
            )}
        </Toolbar>

        <form className={classes.searchBar} onSubmit={e => this.submitSearch(e)}>
          {!onSearch ? null : (
            <div>
              <TextField
                className={classes.spacer}
                placeholder={Y`Search`}
                value={this.setValue(value)}
                onChange={this.inputChanged('searchText')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  },
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton aria-label={Y`Search`} onClick={e => this.submitSearch(e)} style={{ marginTop: '8px' }}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />

              {(!filterProps || filterProps.length === 0) ? null : (
                <div style={ToolbarStyle.filterContainer}>
                {filterProps.map((item, index) => (
                    <TextField style={ToolbarStyle.filterField} key={index}
                      label={!item.label ? '' : item.label}
                      placeholder={!item.placeholder ? '' : item.placeholder}
                      value={!item.value ? '' : item.value}
                      onChange={!item.onChange ? null : item.onChange}
                      select={item.select}
                      SelectProps={item.selectProps}
                      type={!item.type ? 'text' : item.type}
                      required={item.required}
                   >
                   
                    {(!item.selections || item.selections.length === 0) ? null : (
                      item.selections.map((selection, i) => (
                        <MenuItem key={selection.value} value={selection.value}>
                          {selection.label}
                        </MenuItem>
                      ))
                    )}
                   </TextField>
                  ))}
                </div>
              )
              }
            </div>
          )
          }

        </form>
      </div>
    )
  }

}

TableToolbarFilter.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  selection: PropTypes.array,
  filterProps: PropTypes.arrayOf(PropTypes.object),
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  onSearch: PropTypes.func
}


export default withStyles(Styles)(TableToolbarFilter)



// WEBPACK FOOTER //
// ./src/common/tableToolbars/table-toolbar-filter.js